module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/header-date@2x-81dd472618ed640b2b891cac4c55d457.png";